import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, calculateAge, getCurrentDateTime, request, toast } from '../../../../../utils';
import { useCallback, useEffect, useState } from 'react';
import { REPORT_TYPE } from '../../../../../constants/dropdown';
import { CollectionSummaryReport } from './CollectionSummaryReport';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

const initialSchemeAllotmentDataObj = {
  data: [],
  loading: false
};

export const CollectionSummary = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [openPrint, setOpenPrint] = useState(false);
  const [userdata, setUserData] = useState([]);
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        from_date: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
      report: 'bill_wise_collection'
    },
    mode: 'all'
  });

  const { handleSubmit, watch, setValue, reset } = methods;
  const user = JSON.parse(localStorage.getItem('user'));
  console.log('HELLLLLLO USERSSSS', user);
  const getUserList = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user`);
      setUserData(response.data);
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  }, []);
  useEffect(() => {
    getUserList();
  }, []);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const handleExcelReport = async () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    try {
      // Use the SAME endpoint AND SAME refId params as the PDF report
      // (backend requires `report` — without it, it returns an empty payload)
      const response = await axios.get(
        `${BASE_URL}/print/hospital/outpatient-management/collection-summary?refId=${JSON.stringify({
          report: watch('report'),
          user: watch('user'),
          from_date: watch('from_date'),
          to_date: watch('to_date')
        })}`
      );

      if (!response.data.success) {
        toast('Something Went Wrong', { variant: 'error' });
        return;
      }

      const d = response.data.data;
      const opdRows      = d?.opdData?.data            || [];
      const opdBillRows  = d?.opdBillingData?.data     || [];
      const ipdRows      = d?.indoorServiceData?.data  || [];
      const labRows      = d?.labInvestigationData?.data || [];
      const receiptRows  = d?.receiptVoucherData?.data  || [];
      const refundRows   = d?.paymentRefundData?.data   || [];

      const opdStats     = d?.opdData?.stats            || {};
      const opdBillStats = d?.opdBillingData?.stats     || {};
      const ipdStats     = d?.indoorServiceData?.stats  || {};
      const labStats     = d?.labInvestigationData?.stats || {};
      const receiptStats = d?.receiptVoucherData?.stats  || {};
      const refundStats  = d?.paymentRefundData?.stats   || {};

      const totalRows = opdRows.length + opdBillRows.length + ipdRows.length
                      + labRows.length + receiptRows.length + refundRows.length;
      if (totalRows === 0) {
        toast('No Data Found For These Filters', { variant: 'error' });
        return;
      }

      // ── Helpers ──────────────────────────────────────────────────
      const n = (v) => Number(v) || 0;
      const rupees = (v) => n(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const patName = (...parts) => parts.filter(Boolean).join(' ').trim() || '-';
      const svcNames = (arr) => (arr || []).map(s => s.service_name || s.test_name).filter(Boolean).join(', ') || '-';
      // Entry time: use the stored `time` field (String); fall back to createdAt for old records
      const rowTime = (row) => {
        if (row?.time) return String(row.time);
        if (!row?.createdAt) return '-';
        const dt = new Date(row.createdAt);
        if (isNaN(dt)) return '-';
        return `${String(dt.getHours()).padStart(2, '0')}:${String(dt.getMinutes()).padStart(2, '0')}`;
      };

      // ── Column headers (matches PDF) ──────────────────────────────
      const COLS = ['Sr.No.', 'Date', 'Time', 'Type', 'Patient Name', 'UHID', 'Bill/Adm No.',
                    'Pay Mode', 'Consultant', 'Services', 'Panel',
                    'Credit Amt', 'Recd 1', 'Recd 2', 'Recd Amt'];

      // ── AOA builder ───────────────────────────────────────────────
      const rows = [];

      // Title
      rows.push([`BILL WISE COLLECTION SUMMARY REPORT`]);
      rows.push([`Period: ${formatDate(watch('from_date'))} to ${formatDate(watch('to_date'))}   |   Printed: ${formatDate(new Date().toISOString())}`]);
      rows.push([]);

      const pushSection = (title, data, mapFn, subtotalLabel, subtotalAmt) => {
        rows.push([title, '', '', '', '', '', '', '', '', '', '', '', '', `(${data.length} records)`]);
        rows.push(COLS);
        if (data.length === 0) {
          rows.push(['', '', '', 'No records found for this period.']);
        } else {
          data.forEach((row, i) => rows.push(mapFn(row, i)));
        }
        rows.push(['', '', '', '', '', '', '', '', '', '', '', '', '', subtotalLabel, rupees(subtotalAmt)]);
        rows.push([]);
      };

      // ── Section 1 — OPD Registration ──────────────────────────────
      pushSection(
        'OPD REGISTRATION (CONSULTANCY)',
        opdRows,
        (row, i) => [
          i + 1,
          formatDate(row.date),
          rowTime(row),
          'OPD',
          patName(row.name_suffix, row.first_name, row.last_name),
          row.uhid || '-',
          row.adm_no_date || '-',
          row.payment_mode || '-',
          row.consultant?.name || '-',
          'Consultancy',
          row.sponsor?.name || '-',
          row.payment_mode?.toUpperCase() === 'CREDIT' ? rupees(row.bal) : '-',
          '-',
          '-',
          rupees(row.recd)
        ],
        'OPD REGISTRATION TOTAL',
        opdStats.recd_amt
      );

      // ── Section 2 — OPD Billing ────────────────────────────────────
      pushSection(
        'OPD BILLING',
        opdBillRows,
        (row, i) => [
          i + 1,
          formatDate(row.date),
          rowTime(row),
          'OPD Bill',
          patName(row.patient?.name_suffix, row.patient?.first_name, row.patient?.last_name),
          row.uhid || '-',
          row.patient?.adm_no_date || '-',
          row.pay_mode || '-',
          row.patient?.consultant?.name || '-',
          svcNames(row.combinedServiceDetails),
          row.patient?.sponsor?.name || '-',
          row.pay_mode?.toUpperCase() === 'CREDIT' ? rupees(row.balance_amt) : '-',
          row.pay_mode_1 ? `${row.pay_mode_1} ${rupees(row.rec_amt_1)}` : (row.rec_amt_1 ? rupees(row.rec_amt_1) : '-'),
          row.pay_mode_2 ? `${row.pay_mode_2} ${rupees(row.rec_amt_2)}` : (row.rec_amt_2 ? rupees(row.rec_amt_2) : '-'),
          rupees(row.total_recd)
        ],
        'OPD BILLING TOTAL',
        opdBillStats.recd_amt
      );

      // ── Section 3 — IPD Billing ────────────────────────────────────
      pushSection(
        'IPD BILLING',
        ipdRows,
        (row, i) => [
          i + 1,
          formatDate(row.date),
          rowTime(row),
          'IPD Bill',
          patName(row.patient?.name_suffix, row.patient?.first_name, row.patient?.last_name),
          row.patient?.uhid || '-',
          row.ipd_no || '-',
          row.pay_mode || '-',
          row.patient?.consultant?.name || '-',
          svcNames(row.combinedServiceDetails),
          row.patient?.sponsor?.name || '-',
          row.pay_mode?.toUpperCase() === 'CREDIT' ? rupees(row.balance_amt) : '-',
          row.pay_mode_1 ? `${row.pay_mode_1} ${rupees(row.rec_amt_1)}` : (row.rec_amt_1 ? rupees(row.rec_amt_1) : '-'),
          row.pay_mode_2 ? `${row.pay_mode_2} ${rupees(row.rec_amt_2)}` : (row.rec_amt_2 ? rupees(row.rec_amt_2) : '-'),
          rupees(row.total_recd)
        ],
        'IPD BILLING TOTAL',
        ipdStats.recd_amt
      );

      // ── Section 4 — Lab Investigation ──────────────────────────────
      pushSection(
        'LAB INVESTIGATION BILLING',
        labRows,
        (row, i) => [
          i + 1,
          formatDate(row.date),
          rowTime(row),
          'Lab',
          row.patient_name || '-',
          row.uhid || '-',
          row.ipd_no || row.bill_no || '-',
          row.pay_mode || '-',
          row.doctor?.name || '-',
          svcNames(row.combinedServiceDetails),
          row.sponsor?.name || '-',
          row.pay_mode?.toUpperCase() === 'CREDIT' ? rupees(row.balance_amt) : '-',
          row.rec_amt_1 ? rupees(row.rec_amt_1) : '-',
          row.rec_amt_2 ? rupees(row.rec_amt_2) : '-',
          rupees(n(row.rec_amt_1) + n(row.rec_amt_2))
        ],
        'LAB INVESTIGATION TOTAL',
        labStats.recd_amt
      );

      // ── Section 5 — Receipt Vouchers ───────────────────────────────
      pushSection(
        'RECEIPT VOUCHER (IPD ADVANCES)',
        receiptRows,
        (row, i) => [
          i + 1,
          formatDate(row.date),
          rowTime(row),
          'Receipt',
          patName(row.patient?.name_suffix, row.patient?.first_name, row.patient?.last_name),
          row.patient?.uhid || '-',
          row.ipd_no || '-',
          row.payment_mode || '-',
          row.patient?.consultant?.name || '-',
          '-',
          row.patient?.sponsor?.name || '-',
          '-',
          '-',
          '-',
          rupees(row.received_amount)
        ],
        'RECEIPT VOUCHER TOTAL',
        receiptStats.recd_amt
      );

      // ── Section 6 — Payment Refund ─────────────────────────────────
      pushSection(
        'PAYMENT REFUND VOUCHER',
        refundRows,
        (row, i) => [
          i + 1,
          formatDate(row.date),
          rowTime(row),
          'Refund',
          patName(row.patient?.name_suffix, row.patient?.first_name, row.patient?.last_name),
          row.patient?.uhid || '-',
          row.ipd_no || '-',
          row.payment_mode || '-',
          row.patient?.consultant?.name || '-',
          '-',
          row.patient?.sponsor?.name || '-',
          '-',
          '-',
          '-',
          rupees(row.amount)
        ],
        'TOTAL REFUNDED',
        refundStats.recd_amt
      );

      // ── Payment Mode Summary ────────────────────────────────────────
      const billingCash = n(opdStats.recd_amt_cash) + n(opdBillStats.recd_amt_cash) + n(ipdStats.recd_amt_cash) + n(labStats.recd_amt_cash);
      const billingBank = n(opdStats.recd_amt_bank) + n(opdBillStats.recd_amt_bank) + n(ipdStats.recd_amt_bank) + n(labStats.recd_amt_bank);
      const billingBoth = n(opdStats.recd_amt_both) + n(opdBillStats.recd_amt_both) + n(ipdStats.recd_amt_both) + n(labStats.recd_amt_both);
      const totalCredit = n(opdStats.recd_amt_credit) + n(opdBillStats.recd_amt_credit) + n(ipdStats.recd_amt_credit) + n(labStats.recd_amt_credit);
      const receiptCash = n(receiptStats.recd_amt_cash);
      const receiptBank = n(receiptStats.recd_amt_bank);
      const receiptBoth = n(receiptStats.recd_amt_both);
      const receiptTotal = n(receiptStats.recd_amt);
      const refundTotal  = n(refundStats.recd_amt);
      const grandTotal   = billingCash + billingBank + billingBoth + receiptTotal - refundTotal;
      const dayEndCash   = billingCash + receiptCash;
      const dayEndBank   = billingBank + receiptBank;

      rows.push(['COLLECTION SUMMARY']);
      rows.push([]);

      // ── Box 1 — Payment Mode Breakdown (same rows as PDF) ──────────
      rows.push(['PAYMENT MODE BREAKDOWN']);
      rows.push(['Cash (Billing)', '', rupees(billingCash)]);
      rows.push(['Bank/Digital (Billing)', '', rupees(billingBank)]);
      rows.push(['  Bank / UPI / Paytm / NEFT / Card', '', 'included above']);
      if (billingBoth > 0) {
        rows.push(['Both Cash+Bank (Billing)', '', rupees(billingBoth)]);
      }
      rows.push(['Receipt Vouchers (IPD Advances)', '', rupees(receiptTotal)]);
      rows.push(['  - Cash', '', rupees(receiptCash)]);
      rows.push(['  - Bank / Digital', '', rupees(receiptBank)]);
      if (receiptBoth > 0) {
        rows.push(['  - Both', '', rupees(receiptBoth)]);
      }
      rows.push(['(-) Refunds', '', `(${rupees(refundTotal)})`]);
      rows.push(['NET COLLECTED', '', rupees(grandTotal)]);
      rows.push([]);

      // ── Box 2 — Collection by Section (same rows as PDF) ───────────
      rows.push(['COLLECTION BY SECTION']);
      rows.push(['OPD Registration', '', rupees(n(opdStats.recd_amt))]);
      rows.push(['OPD Billing', '', rupees(n(opdBillStats.recd_amt))]);
      rows.push(['IPD Billing', '', rupees(n(ipdStats.recd_amt))]);
      rows.push(['Lab Investigation', '', rupees(n(labStats.recd_amt))]);
      rows.push(['Receipt Vouchers', '', rupees(receiptTotal)]);
      rows.push(['(-) Refunds', '', `(${rupees(refundTotal)})`]);
      rows.push(['Total Net Collected', '', rupees(grandTotal)]);
      rows.push([]);

      // ── Grand Total banner (same as PDF) ───────────────────────────
      rows.push(['GRAND TOTAL COLLECTED (Billing + Receipt Vouchers - Refunds)', '', '', '', '', rupees(grandTotal)]);
      rows.push([]);

      // ── Day-End Closing Summary (same as PDF) ──────────────────────
      rows.push(['DAY-END CLOSING SUMMARY', '', 'CASH', 'BANK / DIGITAL', 'TOTAL']);
      rows.push(['Billing (OPD + OPD Bill + IPD + Lab)', '', rupees(billingCash), rupees(billingBank), rupees(billingCash + billingBank + billingBoth)]);
      rows.push(['Receipt Vouchers (IPD Advances)', '', rupees(receiptCash), rupees(receiptBank), rupees(receiptTotal)]);
      if (refundTotal > 0) {
        rows.push(['(-) Payment Refunds', '', '-', '-', `(${rupees(refundTotal)})`]);
      }
      rows.push(['NET CLOSING BALANCE', '', rupees(dayEndCash), rupees(dayEndBank), rupees(grandTotal)]);

      // ── Credit outstanding notice (same as PDF) ────────────────────
      if (totalCredit > 0) {
        rows.push([]);
        rows.push([`* Credit Outstanding - on account, NOT collected (Cash/Bank flow excluded): ${rupees(totalCredit)}`]);
      }

      // ── Build sheet ────────────────────────────────────────────────
      const ws = XLSX.utils.aoa_to_sheet(rows);

      ws['!cols'] = [
        { wch: 5 },  // Sr
        { wch: 10 }, // Date
        { wch: 9 },  // Time
        { wch: 12 }, // Type
        { wch: 28 }, // Patient Name
        { wch: 10 }, // UHID
        { wch: 12 }, // Bill/Adm No
        { wch: 10 }, // Pay Mode
        { wch: 22 }, // Consultant
        { wch: 28 }, // Services
        { wch: 14 }, // Panel
        { wch: 12 }, // Credit Amt
        { wch: 16 }, // Recd 1
        { wch: 16 }, // Recd 2
        { wch: 12 }, // Recd Amt
      ];

      const wb = { Sheets: { 'Collection Summary': ws }, SheetNames: ['Collection Summary'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: fileType });
      saveAs(blob, `Collection_Summary_${watch('from_date')}_to_${watch('to_date')}${fileExtension}`);

    } catch (err) {
      console.error('Excel export error:', err);
      toast('Failed to generate Excel report', { variant: 'error' });
    }
  };
  
  

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Collection Summary Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('report')}
                  id={`${lastPathSegment}Print`}
                  onClick={() => 
                    window.open(
                      `/print${pathname}${watch('report') === 'user_wise_collection' ? '/user-wise' : watch('report') === 'ref-by-collection' ? '/ref-by-collection' : ''}?refId=${JSON.stringify({ 
                        report: watch('report'), 
                        user: watch('user'), 
                        from_date: watch('from_date'), 
                        to_date: watch('to_date') 
                      })}`, 
                      '_blank'
                    )
                  }
                  
                >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  disabled={!watch('report')}
                  id={`${lastPathSegment}Print`}
                  onClick={handleExcelReport}
                >
                  View Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '60%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={11} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                    <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                  </Stack>
                  <Stack direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Report Type</Typography>
                    <SelectTag formControlSX={{ flex: 0.8 }} name="report" menus={REPORT_TYPE} />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>User</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="user"
                      disabled={watch("report") === "bill_wise_collection"}
                      menus={[{ name: 'All', _id: 'all' },
                        ...(Array?.isArray(userdata) ? userdata?.map((data) => ({
                       ...data,
                        name: `${data.first_name} ${data.last_name}`, _id: `${data.first_name} ${data.last_name} `
                       
                        })) : [])
                        ]}
                    />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <CollectionSummaryReport />
      </Dialog>
    </>
  );
};
